export const GET_DATA_HOME_ADMINISTRATOR = 'GET_DATA_HOME_ADMINISTRATOR'